module.exports = __webpack_public_path__ + "static/img/01.6ca44de.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/agc/items/planibel/01.jpg
// module id = 528
// module chunks = 0